import {useContext} from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import {AuthContext} from '../../contexts/auth/context';
import {AuthContextType} from '../../contexts/auth/types';
import {useEffect} from 'react';
import {SignInError} from '../../enums/sign-in-error';
import {useHistory} from 'react-router-dom';
import {ScreenPaths} from '../../enums/screen-path';

export default function LegacyIntegrationScreen() {
  // Get context
  const authContext: AuthContextType = useContext(AuthContext);

  // Get Navigation
  const history = useHistory();

  // On mount
  useEffect(() => {
    const bootstrap = async (data: any) => {
      // Force logout
      await authContext.signOutLegacyIntegration();

      // Force new login
      const loginResult: SignInError | undefined = await authContext.signInLegacyIntegration(
        data.token
      );

      // Evaluate
      if (!loginResult) {
        // Everything went fine, redirect to office
        history.push(data.redirectToPath);
      } else {
        // Redirect to login
        history.push(ScreenPaths.Login);
      }
    };

    // Bind event listener
    window.addEventListener(
      'message',
      (event) => {
        // Evaluate
        if (event.data && event.data.token && event.data.redirectToPath) {
          // Run
          bootstrap(event.data);
        }
      },
      false
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Backdrop sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}} open={true}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
